module.exports = __webpack_public_path__ + "media/images/front/common/icon_clinic_wiki-e4ff392f3a4111fd27032f645135b17a.svg";